import { useQuery } from "react-query"
import axiosClient from "../../../../../../lib/axios"
import { useState } from "react"
import useDebounce from "../../../../../../lib/useDebounce"
import { IPesquisaCaixaBancos } from "../../../../../../types/api/financeiro/pesquisar-caixa-bancos"
import { IconButton, TableBody, TableCell, Paper } from "@mui/material"
import { Table, TableRow, TableHead } from "@mui/material"
import { TableContainer } from "@mui/material"
import { formatarValorMonetario } from "../../../../../../helpers/masks"
import tratativaDeDatas from "../../../../../../helpers/tratativaDeDatas"
import VisibilityIcon from '@mui/icons-material/Visibility';
import TemplateListagem from "../../../../../../components/BasicComponents/DisplayDados/TemplateListagem"
import DialogLancamentos from "./DialogLancamentos"
import moment from "moment"
import SearchWithFilters from "../../../../../../components/BasicComponents/SearchWithFilters"

export default function Listagem() {

    const [keyword, setKeyword] = useState<string>('')
    const [openDialog, setOpenDialog] = useState<IPesquisaCaixaBancos | null>(null)

    //queries e mutations
    const dbKeyword = useDebounce(keyword, 500)
    const { data, isLoading } = useQuery({
        queryKey: ['extrato-contas', dbKeyword],
        queryFn: () => axiosClient.get('/financeiro/caixa-bancos/pesquisar-caixa-bancos', {
            params: {
                pesquisar: dbKeyword,
                data_saldo: moment().subtract(1, 'day').format('YYYY-MM-DD')
            }
        })
    })
    const listagem: IPesquisaCaixaBancos[] = data?.data || []
    //

    return (
        <Paper
            elevation={2}
            sx={{
                p: 2,
            }}>
            <SearchWithFilters
                palavraChave={keyword}
                textFieldProps={{
                    label: "Pesquisar",
                    placeholder: "Pesquise por emissor, número ou chave da nota",
                    size: "medium",
                }}
                pesquisar={(term) => setKeyword(term)}
                setTermoPesquisa={setKeyword}
                hasFilters={false}
            />
            <TemplateListagem
                isLoading={isLoading}
                isEmpty={listagem.length === 0}
            >
                <TableContainer >
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Código</b></TableCell>
                                <TableCell><b>Nome</b></TableCell>
                                <TableCell align="right"><b>Saldo atual ({tratativaDeDatas(moment().subtract(1, 'day'))})</b></TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listagem.map((row) => (
                                <TableRow
                                    key={row.codigo}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.codigo}
                                    </TableCell>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell
                                        align="right"
                                    >
                                        {formatarValorMonetario(row.saldo)}
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton size="small" onClick={() => setOpenDialog(row)}>
                                            <VisibilityIcon fontSize="inherit" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </TemplateListagem>

            {
                openDialog &&
                <DialogLancamentos
                    open={Boolean(openDialog)}
                    onClose={() => setOpenDialog(null)}
                    banco={openDialog}
                />
            }
        </Paper>
    )
}